<template>
  <div class="py-3">
    <b-row>
      <b-col class="text-center text-md-left">
        <h2 v-show="!registerCompanyOnly" v-translate>Create a new account</h2>
        <h2 v-show="registerCompanyOnly" v-translate>Please, register your company</h2>
        <div v-if="!this.$store.getters.universe.restrictRegisterToCountry">
          <p v-translate>Please, confirm or change your country below.</p>
          <form @submit.prevent="setNewCountry()" class="my-5">
            <b-input-group>
              <b-form-select v-model="country" :options="this.countries.map(x => { if(!x.front_config.hideFromSelect || showAllCountries) return {value: x.iso_code, text: x.name} }).filter(Boolean)" class="form-control" style="font-size: 2rem">
                <template slot="first">
                  <option :value="null" v-translate>Select Country</option>
                </template>
              </b-form-select>
              <b-input-group-append>
                <b-button variant="primary" type="submit" size="lg">
                    <b-spinner small v-if="sending"></b-spinner>
                    <strong v-show="!countryConfirmed" v-translate>Continue</strong>
                    <strong v-show="countryConfirmed" v-translate>Change</strong>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </form>
          <form @submit.prevent="setNewRegion()" class="my-5" v-if="regionsSelect.length > 0">
            <b-input-group>
              <b-form-select v-model="regionId" :options="this.regionsSelect" class="form-control" style="font-size: 2rem">
                <template slot="first">
                  <option :value="null" v-translate>Select Region</option>
                </template>
              </b-form-select>
              <b-input-group-append>
                <b-button variant="primary" type="submit" size="lg">
                    <b-spinner small v-if="sending"></b-spinner>
                    <strong v-show="!regionConfirmed" v-translate>Continue</strong>
                    <strong v-show="regionConfirmed" v-translate>Change</strong>
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-button variant="link" class="px-0" v-if="regionId" v-b-modal.modalViewAreas v-translate="{regionName: this.regionsSelect.find(x => x.value === regionId).text}">View our coverage areas in %{regionName}</b-button>
            <b-modal size="xl" ref="modalViewAreas" id="modalViewAreas" hide-footer hide-header>
              <leaflet-map ref="fullMap" centerMap geolocate fit-always :zoom="14" style="height: 80vh" @ready="mapReady" />
            </b-modal>
          </form>
        </div>
      </b-col>
    </b-row>
    <register-form-moova-self-service-form v-if="regionConfirmed && countryHasSelfService" :register-config="registerConfig" />
    <register-form-moova-form v-if="regionConfirmed && !countryHasSelfService" :register-config="registerConfig" />
  </div>
</template>
<script>
import L from 'leaflet'
import LeafletMap from '@/components/LeafletMap'
import RegisterFormMoovaSelfServiceForm from '@/components/RegisterFormMoovaSelfServiceForm'
import RegisterFormMoovaForm from '@/components/RegisterFormMoovaForm'

export default {
  name: 'RegisterPage',
  title() {
    return this.$gettext('Create a new account')
  },
  components: {
    LeafletMap,
    RegisterFormMoovaSelfServiceForm,
    RegisterFormMoovaForm
  },
  data() {
    return {
      registerConfig: this.$frontConfig.register,
      country: this.$cookies.get('country'),
      countryConfirmed: false,
      regionsSelect: [],
      regionId: null,
      regionConfirmed: false,
      sending: false,
      map: null,
      countryHasSelfService: false,
      theAreas: {}
    }
  },
  computed: {
    registerCompanyOnly() {
      return this.$store.getters.profile && this.$store.getters.profile.company_id === null
    },
    showAllCountries() {
      return this.$route.query.all
    }
  },
  watch: {
    regionId(val) {
      if (val) {
        this.theAreas = this.geoJsons.find(x => x.id === val).geoJsonObject
      } else {
        this.$refs.fullMap.geoJson = null
      }
    }
  },
  created() {
    this.fetchCountries()
    this.fetchAccountingStuff()
  },
  mounted() {
    if (this.$store.getters.universe.restrictRegisterToCountry) {
      this.countryConfirmed = true
    }
  },
  methods: {
    mapReady() {
      this.map = this.$refs.fullMap.$refs.theMap.mapObject
      setTimeout(() => {
        this.map.invalidateSize()
        this.$refs.fullMap.geoJson = this.theAreas
        let geoJSON = L.geoJson(this.$refs.fullMap.geoJson.map(x => x.geoJson))
        setTimeout(() => {
          this.$refs.fullMap.$refs.theMap.mapObject.fitBounds(geoJSON.getBounds())
        }, 500)
      }, 100)
    },
    toUpper(v) {
      return v.masked.toUpperCase()
    },
    setNewCountry() {
      if (this.country !== null) {
        this.$frontConfig = this.countries.find(x => x.iso_code === this.country).front_config || null
        this.$cookies.set('country', this.country, 60 * 60 * 24 * 30, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$cookies.set('phonePrefix', this.$frontConfig.i18n.phonePrefix, 60 * 60 * 24 * 30, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$emit('countryChanged')
      }
      if (this.$frontConfig) {
        this.$language.current = this.$frontConfig.i18n.lang || 'en_US'
        let moment = this.$frontConfig.i18n.moment || 'en'
        this.moment.locale(moment)
      }
      this.resetData()

      if (this.$frontConfig.selfServiceRegionIds) {
        this.countryHasSelfService = true
        this.fetchRegions()
      } else {
        this.countryHasSelfService = false
        this.setNewRegion()
      }
    },
    fetchRegions() {
      let params = {
        sort: [
          {
            key: 'name',
            direction: 'asc'
          }
        ],
        includes: [
          'areas'
        ],
        filter_groups: [
          {
            filters: [
              ['id', 'in', this.$frontConfig.selfServiceRegionIds]
            ]
          }
        ]
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'countries/' + this.country + '/regions', { params })
        .then(response => {
          this.regions = response.body.data
          this.regionsSelect = this.regions.map(x => {
            if (this.$frontConfig.selfServiceRegionIds && this.$frontConfig.selfServiceRegionIds.indexOf(x.id) !== -1) {
              return {
                value: x.id,
                text: x.name
              }
            }
          }).filter(Boolean)
          this.geoJsons = this.regions.map(x => {
            if (this.$frontConfig.selfServiceRegionIds && this.$frontConfig.selfServiceRegionIds.indexOf(x.id) !== -1) {
              return {
                id: x.id,
                geoJsonObject: this.makeGeoJson(x.areas)
              }
            }
          })
        })
    },
    makeGeoJson(areas) {
      let output = []
      for (let i = 0; i < areas.length; i++) {
        if (!areas[i].is_dangerous) {
          output.push(
            {
              geoJson: {
                type: 'Feature',
                properties: {
                  'stroke': '#555555',
                  'stroke-width': 0,
                  'stroke-opacity': 1,
                  'fill': '#ff0000',
                  'fill-opacity': 0.5
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: areas[i].area.coordinates
                }
              },
              objectStyle: {
                weight: 1,
                stroke: areas[i].is_dangerous ? '#ff0000' : '#3388ff',
                color: areas[i].is_dangerous ? '#ff0000' : '#3388ff',
                strokeWidth: 1,
                strokeOpacity: 0.7,
                fillColor: areas[i].is_dangerous ? '#ff0000' : '#3388ff',
                fillOpacity: 0.5
              }
            }
          )
        }
      }
      return output
    },
    setNewRegion() {
      this.regionConfirmed = true
    },
    // addBillingDetailsEmail() {
    //   this.company.billing_details.emails.push(this.newBillingDetailsEmail)
    //   this.newBillingDetailsEmail = ''
    // },
    // removeBillingDetailsEmail(index) {
    //   this.company.billing_details.emails.splice(index, 1)
    // },
    fetchAccountingStuff() {
      let params = {
        sort: [{
          key: 'name',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              ['country_iso_code', 'eq', this.country],
              ['catalog', 'in', ['customer_types', 'document_types', 'states', 'tax_conditions']]
            ]
          }
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'accounting-catalogs', {params: params})
        .then(response => {
          this.accountingCatalogs = response.body.data
        })
      // },
      // fetchMktgStuff() {
      //   let params = {
      //     filter_groups: [
      //       {
      //         filters: [
      //           ['type', 'eq', 'e-commerce-tech']
      //         ]
      //       }
      //     ]
      //   }
      //   this.$http.get(this.$appConfig.api.baseUrl + 'marketing-catalogs', {params: params})
      //     .then(response => {
      //       this.techs = response.body.data
      //     })

      //   params = {
      //     filter_groups: [
      //       {
      //         filters: [
      //           ['type', 'eq', 'industry']
      //         ]
      //       }
      //     ]
      //   }
      //   this.$http.get(this.$appConfig.api.baseUrl + 'marketing-catalogs', {params: params})
      //     .then(response => {
      //       this.industries = response.body.data
      //     })
      // },
      // async checkTin() {
      //   this.sending = true
      //   if (this.registerConfig.endpoint) {
      //     return this.$http.get(this.$appConfig.api.baseUrl + this.registerConfig.endpoint.replace('{tin}', this.company.tin.replace(/[^a-zA-Z0-9]/g, '')))
      //       .then(response => {
      //         this.company = {...this.company, ...this.remapResponse(response.body, this.registerConfig.mapResponse)}
      //         Object.keys(this.company).forEach(key => {
      //           if (key.indexOf('raw') === -1) {
      //             this.company[key] = this.company[key] !== '-' && this.company[key] !== '' ? this.company[key] : null
      //           }
      //         })

      //         this.tinResponse['success'] = true
      //         this.sending = false
      //       }, error => {
      //         this.sending = false
      //         if (this.registerConfig.allowManualOnFailure === true) {
      //           this.failure = true
      //         } else {
      //           let message = ''
      //           if (error.status === 404) {
      //             message = this.$gettext('The TIN has not been found or it\'s invalid. Please, check the number and try again')
      //           } else {
      //             message = this.$gettext('There were an error. Please, try again.')
      //           }
      //           let obj = {
      //             title: 'ERROR',
      //             message: message,
      //             type: 'error',
      //             customCloseBtnText: this.$gettext('Close')
      //           }
      //           this.$root.$children[0].$refs.simplert.openSimplert(obj)
      //         }
      //       })
      //   } else {
      //     if (await checkTinLocal[this.tinCountry].doCheck(this.company.tin)) {
      //       this.tinResponse['success'] = true
      //       this.failure = true
      //       this.sending = false
      //     } else {
      //       this.sending = false
      //       if (this.registerConfig.allowManualOnFailure === true) {
      //         this.failure = true
      //       } else {
      //         let message = this.$gettext('The TIN has not been found or it\'s invalid. Please, check the number and try again')
      //         let obj = {
      //           title: 'ERROR',
      //           message: message,
      //           type: 'error',
      //           customCloseBtnText: this.$gettext('Close')
      //         }
      //         this.$root.$children[0].$refs.simplert.openSimplert(obj)
      //       }
      //     }
      //   }
      // },
      // remapResponse(o, r) {
      //   o = this.flattenObject(o)
      //   return Object.keys(o).map((key) => ({ [r[key] || key]: o[key] })).reduce((a, b) => Object.assign({}, a, b))
      // },
      // flattenObject(objectOrArray, prefix = '', formatter = (k) => (k)) {
      //   const nestedFormatter = (k) => ('.' + k)
      //   const nestElement = (prev, value, key) => (
      //     (value && typeof value === 'object')
      //       ? { ...prev, ...this.flattenObject(value, `${prefix}${formatter(key)}`, nestedFormatter) }
      //       : { ...prev, ...{ [`${prefix}${formatter(key)}`]: value } })

      //   return Array.isArray(objectOrArray)
      //     ? objectOrArray.reduce(nestElement, {})
      //     : Object.keys(objectOrArray).reduce(
      //       (prev, element) => nestElement(prev, objectOrArray[element], element),
      //       {},
      //     )
      // },
      // register() {
      //   this.company.country_iso_code = this.$cookies.get('country')
      //   if (this.failure) {
      //     this.company.meta = {
      //       manualData: true
      //     }
      //   }
      //   this.company.industries = [this.company.industriesSetting]
      //   let company = JSON.parse(JSON.stringify(this.company))

      //   // HACK TODO: REMOVE WHEN BACKEND REGEX FOR CL IS FIXED
      //   if (company.country_iso_code === 'CL' || this.country === 'CL') {
      //     company.tin = company.tin.replace(/(.{1}$)/, '-$1')
      //   }
      //   if (this.registerCompanyOnly) {
      //     this.sending = true
      //     company.user_id = this.$store.getters.profile.id
      //     this.$http.post(this.$appConfig.api.baseUrl + 'users/' + this.$store.getters.profile.id + '/companies', company)
      //       .then(response => {
      //         window.location.href = window.location.origin
      //       }, error => {
      //         this.sending = false
      //         let message = ''
      //         if (error.status === 422) {
      //           for (let i = 0; i < error.body.errors.length; i++) {
      //             message += '- ' + error.body.errors[i].detail + '<br>'
      //           }
      //         } else if (error.status === 409) {
      //           // this.company.is_created = true
      //           message = this.$gettext('The company already exists into our system') + '. ' + this.$gettextInterpolate(this.$gettext('You must contact the person on your company who administer the %{siteName} Dashboard and ask them for your user creation.'), {siteName: this.siteName})
      //         } else {
      //           message = this.$gettext('There were an error creating the company. Please, try again.')
      //         }
      //         let obj = {
      //           title: 'ERROR',
      //           message: message,
      //           type: 'error',
      //           customCloseBtnText: this.$gettext('Close')
      //         }
      //         this.$root.$children[0].$refs.simplert.openSimplert(obj)
      //       })
      //   } else {
      //     if (this.$refs.pwd_check.has_length && this.$refs.pwd_check.pwd_score >= 40) {
      //       this.sending = true
      //       this.$http.post(this.$appConfig.api.baseUrl + 'users/', {
      //         name: this.user.name,
      //         email: this.user.email,
      //         password: this.$refs.pwd_check.password,
      //         country_iso_code: this.$cookies.get('country'),
      //         terms: this.user.terms
      //       }).then(response => {
      //         this.$http.post(this.$appConfig.api.baseUrl + 'users/' + response.body.id + '/companies', company)
      //           .then(response => {
      //             this.$router.push('/login?r=true')
      //           })
      //       }, error => {
      //         this.sending = false
      //         let message = ''
      //         if (error.status === 422) {
      //           for (let i = 0; i < error.body.errors.length; i++) {
      //             message += '- ' + error.body.errors[i].detail + '<br>'
      //           }
      //         } else if (error.status === 404) {
      //           message = this.$gettext('Sorry! We still don\'t bring services in your country :(')
      //         } else {
      //           message = this.$gettext('The email is already registered<br><br>Please <a href=/login>log in</a> with your previous credentials<br>or<br><a href=/password/reset>click here</a> if you forgot your password') // error.body.message
      //         }
      //         let obj = {
      //           title: 'ERROR',
      //           message: message,
      //           type: 'error',
      //           customCloseBtnText: this.$gettext('Close')
      //         }
      //         this.$root.$children[0].$refs.simplert.openSimplert(obj)
      //       })
      //     }
      //   }
      // },
      // authenticate(provider) {
      //   this.$store.dispatch('authenticate', { provider }).then(() => {
      //     this.$router.push('search')
      //   })
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.countryConfirmed = true
      this.fetchCountries()
      // this.fetchMktgStuff()
      this.fetchAccountingStuff()
    }
  }
}

</script>

<style lang="scss">
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, .5);
  top: 0;
  left: 0;
  z-index: 15;
}
</style>
